var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { MuPdf } from '@docext/mupdf';
let MupdfInstance;
export function initMuPdfInstance(file) {
    return __awaiter(this, void 0, void 0, function* () {
        MupdfInstance = new MuPdf();
        yield MupdfInstance.init(yield file.arrayBuffer());
        return MupdfInstance;
    });
}
export function isEncrypted(file) {
    return __awaiter(this, void 0, void 0, function* () {
        const initMuPDF = yield initMuPdfInstance(file);
        const resEncrypted = yield initMuPDF.isPdfEncrypted();
        return resEncrypted;
    });
}
export function isCorrupted(file) {
    return __awaiter(this, void 0, void 0, function* () {
        const initMuPDF = yield initMuPdfInstance(file);
        const resCorrupted = yield initMuPDF.isPdfCorrupted();
        return resCorrupted;
    });
}
export function getUnEmbeddedFontsCount(file) {
    return __awaiter(this, void 0, void 0, function* () {
        const initMuPDF = yield initMuPdfInstance(file);
        const resGetUnEmbeddedFontsCount = yield initMuPDF.getUnEmbeddedFontsCount();
        return resGetUnEmbeddedFontsCount;
    });
}
export function isPasswordProtected(file) {
    return __awaiter(this, void 0, void 0, function* () {
        const initMuPDF = yield initMuPdfInstance(file);
        const resProtected = yield initMuPDF.isPasswordProtected();
        return resProtected;
    });
}
export function convertToImage(file, pageNo, customDpi, format, allowUnEmbeddedFonts = true) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const initMuPDF = yield initMuPdfInstance(file);
            const isCorruptResponse = yield isCorrupted(file);
            if (isCorruptResponse.Corrupted) {
                throw new Error('The PDF is corrupted');
            }
            const isPdfPasswordProtected = yield isPasswordProtected(file);
            if (isPdfPasswordProtected === null || isPdfPasswordProtected === void 0 ? void 0 : isPdfPasswordProtected.PasswordProtected) {
                throw new Error('The PDF is password protected');
            }
            const isPdfEncrypted = yield isEncrypted(file);
            if (isPdfEncrypted === null || isPdfEncrypted === void 0 ? void 0 : isPdfEncrypted.isPdfEncrypted) {
                throw new Error('The PDF is encrypted');
            }
            if (!allowUnEmbeddedFonts) {
                const unEmbeddedFonts = yield getUnEmbeddedFontsCount(file);
                if (unEmbeddedFonts && unEmbeddedFonts.pages[pageNo - 1].UnEmbeddedFontsCount > 0) {
                    throw new Error('The PDF has unembedded fonts');
                }
            }
            let resforconvert;
            if (format === 'PNG') {
                resforconvert = yield initMuPDF.convertPageToPNG(pageNo, customDpi);
            }
            else {
                resforconvert = yield initMuPDF.convertPageToJPG(pageNo, customDpi);
            }
            return URL.createObjectURL(resforconvert);
        }
        catch (error) {
            throw new Error(`Failed to process the PDF file: ${error.message}`);
        }
    });
}
export function getNumberOfPages(file) {
    return __awaiter(this, void 0, void 0, function* () {
        const initMuPDF = yield initMuPdfInstance(file);
        const numberofpages = yield initMuPDF.numberOfPages();
        return numberofpages.NumberOfPages;
    });
}
export function getPDFDetail(file) {
    return __awaiter(this, void 0, void 0, function* () {
        const initMuPDF = yield initMuPdfInstance(file);
        const info = yield initMuPDF.pdfInfo();
        return info;
    });
}
export function getPDFVersion(file) {
    return __awaiter(this, void 0, void 0, function* () {
        const initMuPDF = yield initMuPdfInstance(file);
        const version = yield initMuPDF.getPdfVersion();
        return `PDF${version.PDFVersion}`;
    });
}
//# sourceMappingURL=muPDFCore.js.map